import { render, staticRenderFns } from "./WorkTableChips.vue?vue&type=template&id=4e4e5ac0&scoped=true"
import script from "./WorkTableChips.vue?vue&type=script&lang=js"
export * from "./WorkTableChips.vue?vue&type=script&lang=js"
import style0 from "./WorkTableChips.vue?vue&type=style&index=0&id=4e4e5ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e5ac0",
  null
  
)

export default component.exports